import React from 'react';
import Text from 'components/Text/Text';
import style from './Navigation.module.scss';

interface INavigation {
	navigationItems: string[];
	selectNavigationItem(value: string): void;
	selectedNavigationItem: string | null;
}

const Navigation: React.FC<INavigation> = ({ navigationItems, selectNavigationItem, selectedNavigationItem }) => {
	return (
		<div className={style.container}>
			{navigationItems.map((el) => (
				<div onClick={() => selectNavigationItem(el)} key={el}>
					<Text
						className={selectedNavigationItem === el ? style.selectedItem : style.item}
						translationNameSpace="mediaSettings"
						translationKey={el}
						theme="secondary"
						size="s"
						weight="bold"
					/>
				</div>
			))}
		</div>
	);
};

export default React.memo(Navigation);
